import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
let OnboardingModelImpl = class OnboardingModelImpl {
    constructor() {
        this._messageList = proxy([]);
    }
    get messageList() {
        return this._messageList.value;
    }
    addMessage(messageList) {
        this._messageList.value = [...this._messageList.value, messageList];
    }
    clearMessage() {
        this._messageList.value = [];
    }
    subscribeMessageList(callback) {
        return subscribe(() => this._messageList.value, (newVal) => {
            callback(newVal);
        });
    }
};
OnboardingModelImpl = __decorate([
    injectable()
], OnboardingModelImpl);
export { OnboardingModelImpl };
